function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ClickContainer from 'shared/components/ClickContainer';
import { T } from 'shared/helper/translate';
var DropdownActionsMenu = function DropdownActionsMenu(_ref) {
  var MenuRenderer = _ref.render;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dropdownDisplayed = _useState2[0],
    setDropdownDisplayed = _useState2[1];
  var dismissDropdown = function dismissDropdown() {
    return setDropdownDisplayed(false);
  };
  return /*#__PURE__*/React.createElement(ClickContainer, {
    onClickOutside: dismissDropdown,
    className: "dropdown-actions-menu btn-group p-0 float-end ".concat(dropdownDisplayed ? 'show' : '')
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-sm dropdown-toggle px-0",
    onClick: function onClick() {
      return setDropdownDisplayed(!dropdownDisplayed);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-none d-sm-inline"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Select an action"
  }), dropdownDisplayed ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2",
    icon: "fa-solid fa-caret-up"
  }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2",
    icon: "fa-solid fa-caret-down"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-inline d-sm-none"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "p-2 btn-secondary rounded",
    icon: "fa-solid fa-ellipsis"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-menu p-2 ".concat(dropdownDisplayed ? 'show' : '')
  }, /*#__PURE__*/React.createElement(MenuRenderer, {
    dismissDropdown: dismissDropdown
  })));
};
export default DropdownActionsMenu;